<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle">{{`${locale.nav_coupon} ${locale.category}`}}</h2>
      <div class="add mb15">
        <input type="text" class="input" v-model="value" @keyup.enter="onAddCategory" />
        <button type="button" class="btn" @click="onAddCategory">{{locale.add}}</button>
      </div>
      <CategoryList
        v-if="categoryList.length > 0"
        :list="categoryList"
        :locale="locale"
        @delCategory="delCateogry" />
      <div v-else class="noData">{{locale.category_nodata}}</div>
      <button type="button" class="btn btnFull btnPrimary mt30" @click="onSave(true)">{{locale.save}}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CategoryList from '@/components/Coupon/CategoryList.vue'
import UNIQUE from '@/common/unique'

export default {
  name: 'SetCategory',
  components: {
    CategoryList
  },
  props: [
    'locale'
  ],
  computed: {
    ...mapGetters({
      getCategory: 'coupon/getCategory'
    }),
    categoryList: {
      get () {
        return this.getCategory
      },
      set (val) {
        this.$store.commit('coupon/setCategory', val)
      }
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    onAddCategory () {
      if (this.value.trim().length > 0) {
        const id = UNIQUE.fileid()
        const label = this.value
        this.categoryList.push({
          id: id,
          label: label
        })
        this.value = ''
      }
    },
    delCateogry (id) {
      this.categoryList = this.categoryList.filter(x => x.id !== id)
      this.onSave(false)
    },
    onClose () {
      this.$emit('close')
    },
    onSave (isSave) {
      this.$store.dispatch('coupon/setCategory')
        .then((res) => {
          alert(isSave ? this.locale.complete_save : this.locale.complete_delete)
          this.$store.dispatch('coupon/getCategory')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  text-align: center;
}
.add {
  position: relative;
  .btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }
  .input {
    padding-right: 130px;
  }
}
</style>
